import { create } from 'zustand';

export interface CommandResult {
  commandId: string;
  deviceId: string;
  type: string;
  status: 'PENDING' | 'SENT' | 'CONFIRMED' | 'FAILED' | 'EXPIRED';
  result?: string | null;
  error?: string | null;
}

interface CommandState {
  /** Latest result per commandId */
  byId: Record<string, CommandResult>;
  /** Most recent result per deviceId (for quick "last action" display) */
  byDevice: Record<string, CommandResult>;
  setResult: (result: CommandResult) => void;
}

/**
 * Holds command-result updates pushed over the WebSocket. Lives in a store
 * (not in useSocket's per-instance state) so any component can read the result
 * regardless of which one opened the singleton socket connection.
 */
export const useCommandStore = create<CommandState>((set) => ({
  byId: {},
  byDevice: {},
  setResult: (result) =>
    set((state) => ({
      byId: { ...state.byId, [result.commandId]: result },
      byDevice: { ...state.byDevice, [result.deviceId]: result },
    })),
}));
